import { __generator } from "tslib";
import { call, put, select } from 'redux-saga/effects';
import { request } from '../../xhr';
import { actions, selectors } from '../../Stream';
import { getCurrentMediaSource, getCurrentStreamId, getCurrentGallection, getCurrentSubfolderId, } from '../selectors';
import { getDeviationEntityId } from '../../redux/normalizr/schemas/deviation';
import { MediaSourceType } from '../types';
import { getGallectionType } from '../helpers';
function moveDeviationToPosition(action) {
    var _a, deviation, position, moveType, _b, streamId, currentMediaSource, currentGallection, currentSubfolderId, isFetching, data;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = action.payload, deviation = _a.deviation, position = _a.position, moveType = _a.moveType;
                return [4 /*yield*/, select(function (state) { return ({
                        streamId: getCurrentStreamId(state),
                        currentMediaSource: getCurrentMediaSource(state),
                        currentGallection: getCurrentGallection(state),
                        currentSubfolderId: getCurrentSubfolderId(state),
                    }); })];
            case 1:
                _b = _d.sent(), streamId = _b.streamId, currentMediaSource = _b.currentMediaSource, currentGallection = _b.currentGallection, currentSubfolderId = _b.currentSubfolderId;
                return [4 /*yield*/, select(selectors.isFetching, streamId)];
            case 2:
                isFetching = _d.sent();
                if (!(!moveType || moveType === 'streamOnly')) return [3 /*break*/, 4];
                if (currentMediaSource !== MediaSourceType.CUSTOM_SET && isFetching) {
                    return [2 /*return*/];
                }
                return [4 /*yield*/, put(actions.moveItem({
                        streamId: streamId,
                        item: getDeviationEntityId(deviation),
                        position: position,
                    }))];
            case 3:
                _d.sent();
                _d.label = 4;
            case 4:
                if (currentMediaSource === MediaSourceType.CUSTOM_SET) {
                    return [2 /*return*/];
                }
                if (!(!moveType || moveType === 'papiOnly')) return [3 /*break*/, 6];
                if (!currentGallection) {
                    return [2 /*return*/];
                }
                data = {
                    type: (_c = getGallectionType(currentGallection)) !== null && _c !== void 0 ? _c : 'collection',
                    folderid: currentSubfolderId || currentGallection.folderId,
                    deviationid: deviation.deviationId,
                    position: position,
                };
                return [4 /*yield*/, call(request, {
                        method: 'post',
                        url: 'gallection/folders/update_deviation_order',
                        data: data,
                    })];
            case 5:
                _d.sent();
                _d.label = 6;
            case 6: return [2 /*return*/];
        }
    });
}
export default moveDeviationToPosition;
//# sourceMappingURL=moveDeviationToPosition.js.map